import React from 'react'
import TimeSlotContainer from './TimeSlotContainer'
import NoSlotsAvailable from './NoSlotsAvailable'
import Loader from './Loader'
import { format } from 'date-fns'

const TimeSlotSelector = ({ slotsLoading, selectedDate, setSelectedTime, slots }) => {
  return (
    <div className="appointment-scheduler-time-slot-selector">
      <div className="appointment-scheduler-time-slot-header">
        <div>Available times for { format(selectedDate, "MMMM do, yyyy") }</div>
      </div>
      <div className="appointment-scheduler-time-slot-body">
        <Loader loading={slotsLoading}>
          { slots.length > 0 ?
            <TimeSlotContainer slots={slots} setSelectedTime={setSelectedTime} />
            :
              <NoSlotsAvailable />
          }
        </Loader>
      </div>
    </div>
  )
}

export default TimeSlotSelector
